import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    // Pública, sin authGuard — destino del callback de SSO Office 365
    // (ver MicrosoftAuthController.callback en el backend), que redirige aquí
    // con ?email=&token=&refreshtoken= tras completar el login con Microsoft.
    path: 'ms-auth',
    loadComponent: () =>
      import('./features/auth/ms-auth/ms-auth.component').then((m) => m.MsAuthComponent),
  },
  {
    // Pública, sin authGuard — destino del QR impreso en el PDF de la Constancia Tutorado
    // (ver ConstanciaPublicaController en el backend), cualquiera con el token del QR debe poder
    // confirmar la autenticidad del documento sin iniciar sesión.
    path: 'vc/:token',
    loadComponent: () =>
      import('./features/public/verificar-constancia/verificar-constancia.component')
        .then((m) => m.VerificarConstanciaComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    loadChildren: () =>
      import('./features/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
